import { Fragment } from "react";
import { GeoFeatureSvg, SunExposerSvg, TargetTrackSvg } from "../../../../../CommonComponents/svgs/Svgs";
import { replaceUnderscoresWithSpaces } from "../../../../../../utils/commonFunctions";

const getTimeBaseInfo = (executionType: string, executionReq: any) => {
    if (executionType === "TimeBase" && executionReq?.timeOffset !== undefined) {
        return `T₀ + ${executionReq.timeOffset} min`;
    }
    return null
}

export const getTriggerInfo = (fault: any): string => {
    const executionType = fault?.executionType;
    const executionReq = fault?.executionRequirement;
    const timeBaseInfo = getTimeBaseInfo(executionType, executionReq);
    if (timeBaseInfo) return timeBaseInfo;
    if (executionType === "EventBase") {
        const sun = executionReq?.sunExposure;
        const geo = executionReq?.geofeatureName;

        if (sun && geo) return `${geo} | ${sun}`;
        if (sun) return sun;
        if (geo) return geo;
    }

    return "NA";
};

export const renderGeofeatureIcon = (geofeatureType: string) => {
    return geofeatureType === "Geofence" ? <GeoFeatureSvg /> : <TargetTrackSvg />;
};

export const renderTriggerContent = (fault: any) => {
    const executionType = fault?.executionType;
    const executionReq = fault?.executionRequirement;

    if (executionType === "EventBase") {
        const hasGeofeature = executionReq?.geofeatureType;
        const hasSunExposure = executionReq?.sunExposure;

        if (!hasGeofeature && !hasSunExposure) {
            return 'NA';
        }

        return (
            <div className="faultplan__trigger__content">
                {hasGeofeature && executionReq?.geofeatureType && (
                    <Fragment>
                        <span className="faultplan__trigger__icon" >
                            {renderGeofeatureIcon(executionReq.geofeatureType)}
                        </span>
                        {executionReq?.geofeatureName && (
                            <span className="faultplan__trigger__text" >
                                {replaceUnderscoresWithSpaces(executionReq.geofeatureName)}
                            </span>
                        )
                        }
                    </Fragment>
                )}

                {hasGeofeature && hasSunExposure && <div className="faultplan-trigger-separator" />}

                {hasSunExposure && executionReq?.sunExposure && (
                    <Fragment>
                        <span className="faultplan__trigger__icon" >
                            <SunExposerSvg type={executionReq.sunExposure} />
                        </span>
                        < span className="faultplan__trigger__text" >
                            {replaceUnderscoresWithSpaces(executionReq.sunExposure)}
                        </span>
                    </Fragment>
                )}
            </div>
        );
    }

    const timeBaseInfo = getTimeBaseInfo(executionType, executionReq);
    if (timeBaseInfo) return timeBaseInfo;

    return "NA";
};

